module.exports = __webpack_public_path__ + "img/historia14.0fca413d.jpg";